export default "__VITE_ASSET__tPmyfJlj__"